<template>
  <br />
  <h4 class="text-center">Follows of user #{{ user_id }}</h4>
  <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
    <label for="per-page" class="form-label me-1 mt-2">Per page</label>
    <select id="per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
      <option :value="10">10</option>
      <option :value="20">20</option>
      <option :value="50">50</option>
    </select>
  </div>


  <div class="alert alert-success" role="alert" v-if="success">
    {{ success }}
  </div>
  <div class="alert alert-danger" role="alert" v-if="error">
    {{ error }}
  </div>

  <router-link :to="{ name: 'SingleUser', params: { id: user_id } }">Back to user</router-link>

  <table class="table">
    <thead>
      <tr>
        <th scope="col"># ID</th>
        <th scope="col">Full name, email</th>
        <th scope="col">Creator</th>
        <th scope="col">Started following</th>
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="loading">
        <td colspan="5" class="text-center"><font-awesome-icon icon="fa-solid fa-sync fa-10x" spin /></td>
      </tr>
      <tr v-else-if="follows.length === 0">
        <td colspan="5" class="text-center">No follows found</td>
      </tr>
      <template v-else>
        <tr v-for="follower in follows" :key="follower.id">
          <th scope="row">{{ follower.id }}</th>
          <td>
            <p>{{ follower.user.name }}</p>
            <p>{{ follower.user.email }}</p>
          </td>
          <td>
            <router-link v-if="follower.channel.id" :to="{ name: 'SingleChannel', params: { id: follower.channel.id } }">
              {{ follower.channel.name }}
            </router-link>
            <p v-else>-</p>
          </td>
          <td>{{ follower.created_at }}</td>
          <td>
            <button type="button" class="btn btn-danger"
              @click="unfollowChannel(follower.id, follower.user.id, follower.channel.id)">
              Unfollow
            </button>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
  <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
    <div>
      <div class="p-2">
        <p>Total follows: {{ totalRecords }}</p>
      </div>
    </div>
    <div>
      <div class="p-2">
        <nav v-if="totalPages >= 1" aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" :class="{ disabled: currentPage - 1 < 1 }">
              <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
            </li>
            <li class="page-item" :class="{ active: 1 === currentPage }">
              <a @click="paginate(1)" class="page-link" :class="{ 'not-clickable': currentPage === 1 }">1</a>
            </li>
            <li class="page-item" v-if="currentPage - 2 > 1">
              <a href="#" class="page-link">...</a>
            </li>
            <li class="page-item" v-if="currentPage - 2 > 1">
              <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2 }}</a>
            </li>
            <li class="page-item" v-if="currentPage - 1 > 1">
              <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1 }}</a>
            </li>
            <li class="page-item" v-if="currentPage !== 1" :class="{ active: currentPage }">
              <a @click="paginate(currentPage)" class="page-link" :class="{ 'not-clickable': currentPage }">{{
                currentPage
              }}</a>
            </li>
            <li class="page-item" v-if="currentPage + 1 <= totalPages">
              <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1 }}</a>
            </li>
            <li class="page-item" v-if="currentPage + 2 <= totalPages">
              <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2 }}</a>
            </li>
            <li class="page-item" v-if="currentPage + 2 < totalPages">
              <a href="#" class="page-link">...</a>
            </li>
            <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages"
              :class="{ active: totalPages === currentPage }">
              <a @click="paginate(totalPages)" class="page-link"
                :class="{ 'not-clickable': totalPages === currentPage }">{{ totalPages }}</a>
            </li>
            <li class="page-item" :class="{ disabled: currentPage + 1 > totalPages }">
              <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>


<script>

import axios from 'axios';
import _debounce from "lodash/debounce";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      loading: true,
      follows: [],
      user_id: this.$route.params.id,
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      perPage: 10,
      success: '',
      error: ''
    }
  },

  mounted() {
    this.getUserFollows(this.user_id, 1, this.perPage);
  },

  methods: {
    debouncedGetUserFollows: _debounce(function (user_id, page, perPage) {
      this.loading = true;
      axios.get(`/admin/follows/get?page=${page}&per_page=${perPage}&user_id=${user_id}`).then(response => {
        this.follows = response.data.data;
        this.totalPages = response.data.totalPages;
        this.totalRecords = response.data.totalRecords;
        this.loading = false;
      })
        .catch(error => {
          this.loading = false;
        });
    }, 500),
    getUserFollows(user_id, page, perPage) {
      this.loading = true;
      this.debouncedGetUserFollows(user_id, page, perPage);
    },
    perPageFilter(perPage) {
      this.perPage = perPage;
      this.currentPage = 1;
      this.getUserFollows(this.user_id, this.currentPage, this.perPage);
    },
    paginate(page) {

      this.currentPage = page;
      this.getUserFollows(this.user_id, this.currentPage, this.perPage);
    },

    async unfollowChannel(id, user_id, channel_id) {

      const confirmed = await Swal.fire({
        title: 'Confirmation',
        text: `Are you sure you want to unfollow?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'Cancel'
      });

      if (confirmed.isConfirmed) {
        this.success = '';
        this.error = '';
        await axios.post(`admin/follows/unfollow-for-user`, {
          'user_id': user_id,
          'channel_id': channel_id
        })
          .then(() => {
            this.follows = this.follows.filter(f => f.id !== id);
            this.totalRecords--;
            this.success = 'Successfully unfollowed!';

            if (this.follows.length === 0) {
              let newPage = this.currentPage > 1 ? this.currentPage - 1 : 1;
              this.currentPage = newPage;
              this.getUserFollows(this.user_id, this.currentPage, this.perPage);
            }

          })
          .catch(error => {
            if (error.response.status === 422 || error.response.status === 409) {
              this.error = error.response.data.message;
            }
          })
      }
    },

  }
}
</script>
